 // Import and expose jQuery globally
import $ from 'jquery';
window.$ = window.jQuery = $;


$(document).ready(function () {

    //show menu
       $('.btn-toggle').click(function(){
           $('body').addClass('menu-visible');
       });
   //close menu
    $('.close-menu').click(function(){
        $('body').removeClass('menu-visible');
    });


     if ($(window).width() < 992) {
         $('#header-menu > li.menu-item').click(function(){
             $(this).toggleClass('active');
          });
      }

      $('.submit-on-change').on('change', function(){
                    $(this).closest('form').submit();
                });


      $('.wysiwyg').each(function () {
            wp.editor.initialize(this.id, {
                tinymce: {
                    wpautop: true,
                    plugins: 'lists link paste',
                    // toolbar1: 'bold italic bullist numlist link unlink undo redo',
                    toolbar1: 'bold,italic,bullist,numlist,blockquote,alignleft,aligncenter,alignright,link,unlink,image,table,undo,redo',
                    toolbar2: 'charmap',
                },
                quicktags: false,
                mediaButtons: false,
            });

        });
        
        $('.btnToggleJs').click(function() {
                $(this).closest('.profile-left').toggleClass('show');
            });


        if ($('#stellen').length) {

        $('#stellen').DataTable({
                responsive: true,
                searching: false,
                paging: false,
                info: false,
                columnDefs: [ {
                targets: [$('#stellen th').length-1], // column index (start from 0)
                orderable: false, // set orderable false for selected columns
             }]
            });
            $('.dataTables_empty').text('Keine Angebote verfügbar');
            $(document).on('click', '.delete-job', function (e) {
              if (!confirm("Soll der Standort wirklich gelöscht werden?")){
                return false;
              }
            });
        }
            if ($('#job_beginn').length) {

            $('#job_beginn').datepicker($.extend({}, $.datepicker.regional['de'], {
               // debug: true
            }));
             $('#job_pub_beginn').datepicker($.extend({}, $.datepicker.regional['de'], {
               // debug: true
            }));
            $('#job_pub_ende').datepicker($.extend({}, $.datepicker.regional['de'], {
               // debug: true
               minDate: new Date()
            }));
             $(".btnDateJs").click(function () {
            $(this).prev('.form-control').focus();
        });

         }

            $(':radio[name="job_ganzjaehrig"]').change(function(e) {
          if(this.value == 1){
            $("#job_beginn").val('');
            $("#job_beginn").attr('disabled',true);
          }
          else{
            $("#job_beginn").attr('disabled',false);
            $('#job_beginn').datepicker($.extend({}, $.datepicker.regional['de'], {
               // debug: true
               minDate: new Date()
            }));
            let dateToConvert = new Date();
            $('#job_beginn').val(dateToConvert.toLocaleString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Europe/Berlin' }));
          }
        });

});

jQuery(document).on('click', '#company-load-more', function(e) {
        e.preventDefault(); // verhindert das Standardverhalten des <a>-Tags
            var button = jQuery(this);
            var page   = button.data('page');
            var letter   = button.data('letter');
            jQuery.ajax({
                url: '/wp-admin/admin-ajax.php', // WP stellt ajaxurl automatisch bereit
                type: 'POST',
                data: {
                    action: 'load_company',
                    page: page,
                   letter: letter
                },
                success: function(response) {
                    button.closest('.isloadmore_posts_wrap').remove(); // alten Button entfernen
                    jQuery('#company_container').append(response);
                }
            });
});

document.addEventListener('DOMContentLoaded', function() {

    
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('add-participant')) {
        const participants = e.target.closest('.participants');
        const fields = participants.querySelector('.participant-fields');

        const row = document.createElement('div');
        row.className = 'participant-row';

        row.innerHTML = `
          <input type="text" name="participants[]" placeholder="Teilnehmer hinzufügen">
        `;

        jQuery('.participant-fields').append('<input type="text" name="participants[]" placeholder="Teilnehmer hinzufügen">');
      }

      if (e.target.classList.contains('remove-participant')) {
        e.target.closest('.participant-row').remove();
      }
    });



        // Only target form 957
        var field = document.querySelector('#wpforms-957-field_10');
            console.log(field);
        if (field) {
            var label = field.querySelector('label');
            console.log(label);
            if (label) {
                label.innerHTML = 'Hiermit bestätige ich die <a href="https://www.invest-swm.de/datenschutz" target="_blank" rel="noopener">Datenschutzbestimmungen</a>.';
            }
        }
});


function updateList(inp,out) {
  var input = document.getElementById(inp);
  var output = document.getElementById(out);

  if(inp == "companypictures"){
    if(input.files[0].size > 2097152){
       alert("File is too big!");
       input.value = "";
    };
  }
  var outputString = "<ul class='img-list'>";
  for (var i = 0; i < input.files.length; ++i) {
    outputString += '<li>' + input.files.item(i).name + '</li>';
  }
  outputString+= '</ul>';
  output.innerHTML = outputString;
}

window.updateList = updateList;